import { Directive, HostBinding, Input } from '@angular/core';

import { PopularBetsPodTheme } from '@frontend/sports/types/components/popular-bets';

import { PodEventsModel } from '../popular-bets.models';

@Directive({
    selector: '[msPopularBetsPodBackground]',
    standalone: true,
})
export class PopularBetsPodBackgroundDirective {
    @Input() pod!: PodEventsModel;

    @HostBinding('style.background')
    get background() {
        const { backgroundImage, backgroundStyle } = this.pod;
        return backgroundImage?.src ? 'none' : backgroundStyle || '';
    }

    @HostBinding('class')
    get themeClass() {
        const hasBackground = Boolean(this.pod.backgroundImage?.src || this.pod.backgroundStyle);
        const lightTheme = 'pod-light-theme';
        const darkTheme = 'pod-dark-theme';

        if (this.pod.podTheme === PopularBetsPodTheme.Light) return lightTheme;
        if (this.pod.podTheme === PopularBetsPodTheme.Dark) return darkTheme;
        if (hasBackground) return darkTheme;

        return 'pod-light-theme';
    }
}
